import { render, staticRenderFns } from "./PartDefectInput.vue?vue&type=template&id=475f0480&"
import script from "./PartDefectInput.vue?vue&type=script&lang=js&"
export * from "./PartDefectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports